<template>
  <div>
    <div class="flex sidebar-topfixpart bg-primary p-4">
      <feather-icon
        icon="ChevronLeftIcon"
        @click="handleBack"
        class="cursor-pointer text-white"
        svgClasses="w-6"
      ></feather-icon>
      <h2 class="h2-class font-semibold text-white pl-4">CHOOSE CHANNEL</h2>
    </div>
    <div class="">
      <div
        class="flex items-center justify-between cursor-pointer py-3 px-4 list-group-item border-l-0 border-r-0"
        v-for="(channel, index) in channels"
        :key="'channel-' + index"
      >
        <div>
          <!-- <b-form-radio
            @change="selectedChannelLocal = channel._id"
            v-model="selectedChannelLocal"
            name="selected-channel"
            :value="channel._id"
          > 
          <b-form-group
            @change="selectedChannelLocal = channel._id"
            v-model="selectedChannelLocal"
            name="selected-channel"

          > -->
          <!-- <b-form-group name="selected-channel">
            <b-form-checkbox :value="channel._id"> -->
          <div
            class="flex items-center px-2"
            @click="channelSelected(channel._id)"
          >
            <RadioButton
              :addpart="selectedChannelLocal.includes(channel._id)"
            />

            <div class="flex items-center">
              <img
                alt="user"
                class="w-9 h-9 object-cover rounded-full"
                :src="channelImage(channel)"
              />
              <h4 class="font-semibold ml-4">{{ channel.name }}</h4>
            </div>
          </div>
          <!-- </b-form-checkbox>
          </b-form-group> -->
          <!-- </b-form-radio> -->
        </div>
      </div>
      <base-button
        block
        type="primary"
        :disabled="!isValid"
        class="rounded-none font-semibold w-3/4 m-auto mt-12"
        @click.stop="handleCreate"
        >POST</base-button
      >
    </div>
    <div
      class="footer-fix md:fixed lg:fixed bottom-0 md:w-1/4 lg:w-1/4 w-full mobile-sidebarfooter"
    ></div>
  </div>
</template>

<script>
import RadioButton from "./RadioButton.vue";
import { mapGetters, mapState } from "vuex";

export default {
  props: {
    Back: Function,
  },
  data() {
    return {
      mediaPosts: ["image", "video", "audio"],
    };
  },
  components: {
    RadioButton,
  },
  computed: {
    ...mapGetters("posts", {
      channels: "postingChannels",
    }),
    ...mapState("posts", {
      selectedChannel: "selectedChannel",
      media: "media",
      text: "text",
      url: "url",
      type: "type",
      Answers: "Answers",
      previousPage: "previousPage",
    }),
    selectedChannelLocal: {
      get() {
        return this.selectedChannel || [];
      },
      set(val) {
        this.$store.commit("posts/SET_POST", {
          key: "selectedChannel",
          value: val,
        });
      },
    },
    isValid() {
      return !!this.selectedChannelLocal.length;
    },
  },
  methods: {
    channelSelected(Id) {
      let Channel = this.selectedChannelLocal.find((el) => el == Id);
      if (Channel) {
        this.selectedChannelLocal = this.selectedChannelLocal.filter(
          (el) => el !== Id
        );
      } else {
        this.selectedChannelLocal = [...this.selectedChannelLocal, Id];
      }
      // console.log("das", this.selectedChannelLocal);
    },
    handleBack() {
      this.selectedChannelLocal = "";
      this.$store.commit("posts/SET_CURRENT_PAGE", this.previousPage);
    },
    channelImage(channel) {
      return `${this.$imageURL}/${channel.picture}`;
    },
    async handleCreate() {
      try {
        if (this.mediaPosts.includes(this.type)) {
          await this.createPostWithMedia();
        } else if (this.type == "poll") {
          await this.createPoll();
        } else {
          await this.createPost();
        }

        this.$emit("closeSidebar");
        // if (result.isConfirmed) {
        await this.$store.dispatch(
          "posts/getChannelPosts",
          this.selectedChannel[0]
        );
        await this.$store.dispatch("channel/GetChannel", {
          channelID: this.selectedChannel[0],
        });
        // }
        this.selectedChannelLocal = "";
        await this.$store.commit("posts/RESET_CREATE_POST");
        let result = await this.$swal({
          title: "",
          text: "Your post has been created",
          icon: "success",
          showCancelButton: false,
          confirmButtonText: "Okay",
          cancelButtonText: "",
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error) this.$swal("", "Something went wrong", "error");
      }
    },
    async createPoll() {
      const PollPayload = {
        type: this.type,
        question: this.text,
        choices: this.Answers.filter((el) => el),
        channelId: this.selectedChannel,
      };

      let loader = this.$loading();
      try {
        await this.$store.dispatch("posts/createPoll", PollPayload);
        loader.close();
      } catch (error) {
        if (error.response.status == 400) {
          loader.close();
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          this.$router.push({ name: "signin" });
        } else if (error) {
          loader.close();
        }
      }
    },
    async createPost() {
      const payload = {
        type: this.type,
        text: this.text,
        channelId: this.selectedChannel,
      };

      if (this.type === "url") {
        payload.url = this.url;
      }
      let loader = this.$loading();
      try {
        this.$store.dispatch("posts/CreatePost", payload);
        loader.close();
      } catch (error) {
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error) {
          loader.close();
        }
      }
    },
    async createPostWithMedia() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("type", this.type);
      data.append("text", this.text);
      data.append("media", this.media);
      data.append("channelId", this.selectedChannel);

      let loader = this.$loading();
      try {
        await this.$store.dispatch("posts/createWithMedia", data);
        loader.close();
      } catch (error) {
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error) {
          loader.close();
        }
      }
    },
  },
};
</script>
